import React from 'react';
import { useTranslation } from 'react-i18next';

import { CATEGORY } from '../../../constants';
import LinksBoxWithName from '../LinksBoxWithName/LinksBoxWithName';
import LinksBoxWithEntries from '../LinksBoxWithEntries/LinksBoxWithEntries';
import Loader from '../Loader/Loader';

const Aside = props => {
    const { t } = useTranslation();
    const { isFetchingAlerts, isAlertCategory, alertsError, alerts, isFetchingContent, contentError, contentHeader, content, entries, categoryId } = props;

    const renderContent = () => {
        if (!isFetchingContent && !contentError && content?.length > 0) {
            if (!entries) {
                return (
                    <LinksBoxWithName
                        isFetching={isFetchingContent}
                        links={content}
                        boxName={t('ui.aside.categories')}
                    />
                );
            }
            return (
                <LinksBoxWithEntries
                    isFetching={isFetchingContent}
                    entries={entries}
                    category={categoryId}
                    boxName={contentHeader}
                />
            );
        }
        return;
    };

    return (
        <aside className="help-page__aside" data-cy="category-aside">
            {isFetchingAlerts && isFetchingContent
                ? <Loader spinner />
                : <>
                    {!isAlertCategory && !alertsError && alerts?.length > 0 && (
                        <LinksBoxWithName
                            isFetching={isFetchingAlerts}
                            links={alerts}
                            category={CATEGORY.alerts}
                            boxName={t('ui.aside.alerts')}
                        />
                    )}
                    {renderContent()}
                </>
            }
        </aside>
    );
};

export default Aside;
